define.alias("shared/utils/is-async-relation", "calendar/utils/is-async-relation");